module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    attrs: {
      "id": "content_404"
    }
  }, [_c('div', {
    staticClass: "bg"
  }, [_c('img', {
    attrs: {
      "src": require("./../assets/img/404-bg.png")
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t("title_404")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("text_line_1_404"))), _c('br'), _vm._v(_vm._s(_vm.$t("text_line_2_404")))]), _vm._v(" "), _c('router-link', {
    staticClass: "back_button",
    attrs: {
      "to": '/'
    }
  }, [_vm._v(_vm._s(_vm.$t("button_404")))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8e2f2ba"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/404.vue
// module id = 817
// module chunks = 0